module.exports = __webpack_public_path__ + "img/ep_shield.8f98c03b.svg";